export default "__VITE_ASSET__C6XD227t__"